/*
 *
 * Recommendations actions
 *
 */

import {
  GET_RECOMMENDATIONS_FAILED,
  GET_RECOMMENDATIONS_SUCCESS,
  GET_RECOMMENDATIONS_WATCHER,
} from "./constants"

export function getRecommendationsWatcher(payload) {
  return {
    type: GET_RECOMMENDATIONS_WATCHER,
    payload,
  }
}

export function getRecommendationsSuccess(payload) {
  return {
    type: GET_RECOMMENDATIONS_SUCCESS,
    payload,
  }
}

export function getRecommendationsFailed() {
  return { type: GET_RECOMMENDATIONS_FAILED }
}
